export default {
  root: {
    flex: 1,
    flexDirection: 'column',
    padding: 50,
    backgroundColor: 'light-gray',
    height: '100vh',
    alignItems: 'center',
  },
}
